Ext.define('SA.SessionState', {
    constructor() {
        this._replacedOrExpired = false;
        this.observable = new Ext.util.Observable();
    },

    on(event, listener, scope) {
        this.observable.on(event, listener, scope);
    },

    onReplacedOrExpired() {
        this._replacedOrExpired = true;
        this.observable.suspendEvents();
    },

    replacedOrExpired() {
        return this._replacedOrExpired;
    },

    setDirty() {
        this.observable.fireEvent('dirty');
        this.observable.suspendEvent('dirty');
    },

    setExpired() {
        this.observable.fireEvent('expired');
        this.onReplacedOrExpired();
    },

    setReplaced() {
        this.observable.fireEvent('replaced');
        this.onReplacedOrExpired();
    }
});